import React, { useState } from "react";
import "./login.css";
import instance from "../../ApiInstance/Inetrceptor";
import {
  TextField,
  Button,
  Typography,
  Grid,
  InputAdornment,
  IconButton,
  Alert,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import CustomizedTooltips from "../common/CustmizedTooltip";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";

const Resetpassword = () => {
  const location = useLocation();
  let { mailId, otp } = location.state;
  console.log(mailId, "mailIdmailId");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmpassword] = useState("");
  const [error, setError] = useState("");
  const [passwordPlaceholder, setPasswordPlaceholder] =
    useState("New Password");
  const [confirmpasswordPlaceholder, setConfirmpasswordPlaceholder] = useState("Confirm New Password");
  const [showPasswordIcon, setShowPasswordIcon] = useState(false);
  const [showconfirmPasswordIcon, setShowconfirmPasswordIcon] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showStrengthBar, setShowStrengthBar] = useState(false);
  const [colorAccordingTocondition, setColorAccordingToCondition] = useState({
    weak: false,
    fair: false,
    strong: false,
    medium: false,
  });
  const getPasswordStrength = (password) => {
    const regex = {
      weak: /^.{1,5}$/,
      medium: /^(?=.{6,})((?=.*[A-Z])|(?=.*[a-z])|(?=.*[0-9])).*$/,
      fair: /^(?=.{6,8}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+}{"':;?/>.<,|[\]\\\-]).*$/,
      strong:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+}{"':;?/>.<,|[\]\\\-]).{8,}$/,
    };

    if (!password.trim()) {
      return "empty";
    } else if (regex.strong.test(password)) {
      return "strong";
    } else if (regex.fair.test(password)) {
      return "fair";
    } else if (regex.medium.test(password)) {
      return "medium";
    } else if (regex.weak.test(password)) {
      return "weak";
    } else {
      return "weak"; // Default to weak if no criteria match
    }
  };
  const passwordStrength = getPasswordStrength(password);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (!showStrengthBar && e.target.value.trim() !== "") {
      setShowStrengthBar(true);
    } else if (showStrengthBar && e.target.value.trim() === "") {
      setShowStrengthBar(false);
    }
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmpassword(event.target.value);
  };
  const handleTogglePassword = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
    } else if (field === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const handlePasswordFocus = () => {
    setPasswordPlaceholder("Enter your new password");
    setShowPasswordIcon(true);
  };
  const handlePasswordBlur = (event) => {
    if (event.target.value.trim() === "") {
      setPasswordPlaceholder("New Password");
      setShowPasswordIcon(false);
    }
  };
  const handleConfirmPasswordFocus = () => {
    setConfirmpasswordPlaceholder("Re-type your Password");
    setShowconfirmPasswordIcon(true);
  };

  const handleConfirmPasswordBlur = (event) => {
    if (event.target.value.trim() === "") {
      setConfirmpasswordPlaceholder("Confirm New Password");
      setShowconfirmPasswordIcon(false);
    }
  };
  const handleCloseError = () => {
    setError(""); // Clear the error message
  };
  const handleLogin = () => {
    const newpassword = password;
    const Confirmpassword = confirmpassword;

    if (!newpassword || !Confirmpassword) {
      setError("Please enter password or confirm password");
    } else {
      const passwordStrength = getPasswordStrength(newpassword);

      if (passwordStrength !== "strong") {
        setError(
          "Password is not strong enough. Please use a stronger password."
        );
      } else if (newpassword !== Confirmpassword) {
        setError("Passwords do not match. Please re-enter matching passwords.");
      } else {
        setError("");
        resetPassword();
        console.log("working");
      }
    }
  };
  const resetPassword = () => {
    const body = {
      Id: 0,
      Email: mailId,
      password: password,
      Otp: otp,
    };
    try {
      // setBackDrop(true);
      instance
        .post(`api/v1/User/ResetPassword`, body)
        .then((res) => {
          if (res?.data?.Success) {
            setError(null);
            navigate("/login");
          } else {
            setError(res?.data?.ResultMessage);
            setTimeout(() => {
              setError(null);
            }, 5000);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          // setBackDrop(false);
        });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Grid container sx={{ height: "100%" }}>
      <Grid
        item
        lg={7}
        md={6}
        xs={12}
        sm={12}
        sx={{
          backgroundImage: "url(assets/Images/LoginBackground.svg)",
          backgroundSize: "cover",
          borderBottomRightRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      ></Grid>
      <Grid item lg={5} md={6} xs={12} sm={12}>
        <div className="Logo-style">
          <img
            src="assets/Images/Logo.svg"
            alt="Logo"
            style={{
              width: "40%",
              height: "15%",
              // objectFit: 'cover',
            }}
          />
          <Typography variant="h7" component="h1" className="font-color ">
            New Password
          </Typography>
          <Typography
            variant="h6"
            component="h1"
            className="font-sizehead font-color mt-4"
          >
            Enter your new password to continue
          </Typography>
          {error && (
            <Alert
              variant="outlined"
              severity="error"
              icon={<CancelIcon onClick={handleCloseError} />}
              className="errorAlert mt-4"
            >
              {error}
            </Alert>
          )}
          <TextField
            required
            id="password"
            name="password"
            label="New Password"
            className="mt-4"
            fullWidth
            autoComplete="current-password"
            variant="standard"
            type={showPassword ? "text" : "password"}
            onFocus={handlePasswordFocus}
            onBlur={(event) => handlePasswordBlur(event)}
            onChange={handlePasswordChange}
            InputProps={{
              startAdornment: showPasswordIcon && (
                <InputAdornment position="start">
                  <IconButton>
                    <LockIcon />
                  </IconButton>
                </InputAdornment>
              ),
              placeholder: passwordPlaceholder,
              endAdornment: (
                <InputAdornment
                          position="end"
                          style={{ position: "absolute", right: 20 }}
                        >
                  <IconButton onClick={() => handleTogglePassword("password")}>
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              style: { color: "black" },
            }}
          />
          {showStrengthBar && (
            <>
              <div className="password-strength-bar">
                <div className={`part part1 ${passwordStrength}`}></div>
                <div className="gap"></div>
                <div className={`part part2 ${passwordStrength}`}></div>
                <div className="gap"></div>
                <div className={`part part3 ${passwordStrength}`}></div>
                <div className="gap"></div>
                <div className={`part part4 ${passwordStrength}`}></div>
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <p>Password Strength: {passwordStrength}</p>
                <CustomizedTooltips password={password} />
              </div>
            </>
          )}

          <TextField
            required
            id="confirmpassword"
            name="confirmpassword"
            label="Confirm New Password"
            className="mt-5"
            fullWidth
            autoComplete="current-password"
            variant="standard"
            type={showConfirmPassword ? "text" : "password"}
            onFocus={handleConfirmPasswordFocus}
            onBlur={(event) => handleConfirmPasswordBlur(event)}
            onChange={handleConfirmPasswordChange}
            InputProps={{
              startAdornment: showconfirmPasswordIcon && (
                <InputAdornment position="start">
                  <IconButton>
                    <LockIcon />
                  </IconButton>
                </InputAdornment>
              ),
              placeholder: confirmpasswordPlaceholder,
              endAdornment: (
                <InputAdornment
                          position="end"
                          style={{ position: "absolute", right: 20 }}
                        >
                  <IconButton
                    onClick={() => handleTogglePassword("confirmPassword")}
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            InputLabelProps={{
              style: { color: "var(--color-primary)" },
            }}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            onClick={handleLogin}
            className="button-style"
            color="secondary"
          >
            Reset password
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Resetpassword;
